'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdClosedCaption = function MdClosedCaption(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30 18.4v-1.8c0-0.9-0.7-1.6-1.6-1.6h-5c-1 0-1.8 0.7-1.8 1.6v6.8c0 0.9 0.8 1.6 1.8 1.6h5c0.9 0 1.6-0.7 1.6-1.6v-1.8h-2.5v0.9h-3.4v-5h3.4v0.9h2.5z m-11.6 0v-1.8c0-0.9-0.8-1.6-1.8-1.6h-5c-0.9 0-1.6 0.7-1.6 1.6v6.8c0 0.9 0.7 1.6 1.6 1.6h5c1 0 1.8-0.7 1.8-1.6v-1.8h-2.5v0.9h-3.4v-5h3.4v0.9h2.5z m13.2-11.8c1.8 0 3.4 1.6 3.4 3.4v20c0 1.8-1.6 3.4-3.4 3.4h-23.2c-1.9 0-3.4-1.6-3.4-3.4v-20c0-1.8 1.5-3.4 3.4-3.4h23.2z' })
        )
    );
};

exports.default = MdClosedCaption;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/closed-caption.js
// module id = 1313
// module chunks = 168707334958949